import * as React from "react";
import type { SVGProps } from "react";
const SvgEuro = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#euro_svg__a)">
      <path d="M13 20a6.54 6.54 0 0 1-4.95-2.34A8.9 8.9 0 0 1 8 6.46 6.56 6.56 0 0 1 13 4a6.42 6.42 0 0 1 5 2.34 1 1 0 1 1-1.5 1.32A4.58 4.58 0 0 0 13 6a4.59 4.59 0 0 0-3.52 1.74 6.83 6.83 0 0 0 .07 8.6A4.58 4.58 0 0 0 13 18a4.58 4.58 0 0 0 3.45-1.66A1.018 1.018 0 0 1 18 17.66 6.54 6.54 0 0 1 13 20" />
      <path d="M13 15H5a1 1 0 0 1 0-2h8a1 1 0 0 1 0 2m0-4H5a1 1 0 0 1 0-2h8a1 1 0 1 1 0 2" />
    </g>
    <defs>
      <clipPath id="euro_svg__a">
        <path fill="#fff" d="M4 4h14.2v16H4z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgEuro;
